import React from "react";
import { View, Text } from "react-native"
import {TaskSuccess,Form} from "../../../../../components/SharedComponents";
import { global, colors } from "../../../../../utils";
import { withRouter } from "react-router-dom";
import localize from "../../../../../shared/localize";

function InvitationSuccess({ invite, familyName, history }) {

    const _navigate = () => {
        history.push("/dashboard");
    }

    return (
        <View>
            <TaskSuccess
                title={`${localize.Thanks_for_building_your}  ${familyName} ${localize.team}!`}
                point=""
                buttonPress={() => null}
                component={(
                    <View style={{ marginHorizontal: 30 }}>
                        <View style={{ alignItems: "center", marginVertical: 20 }}>
                            <View style={{ marginVertical: 20 }}>
                                <Text style={{ textAlign: 'center', fontSize: 15, fontStyle: 'italic', fontFamily: global.FONT_REGULAR, fontWeight: "400", color: colors.midnightBack }}>
                                    {invite.replace(new RegExp(/[,\;/]/, 'g'), ', ')}
                                </Text>
                            </View>
                            <Text style={{ fontSize: 16, textAlign: 'center', fontFamily: global.FONT_REGULAR, fontWeight: "400", color: colors.midnightBack }}>
                                {localize.Your_team_will_get_20_points_for_every_new_person_who_joins}
                            </Text>
                        </View>
                        <Form.Button
                            title={localize.Done}
                            size="small"
                            onPress={_navigate}
                        />
                    </View>
                )}
            />
        </View>
    )
}

export default withRouter(InvitationSuccess);